// Words a document puts where a value will come later or doesn't apply.
// They are never the field's value: a template maps them to an empty value.
const PLACEHOLDERS = [
  'volgt',
  'n/a',
  'n.a.',
  'na',
  'nvt',
  'n.v.t.',
  'not applicable',
  'tbd',
  'tba',
  'tbc',
  '-',
  '--',
  '?',
];

const escape = (text: string) => text.replace(/[.*+?^${}()|[\]\\/-]/g, '\\$&');

/** A regular expression source matching a whole value that is a placeholder. */
export const PLACEHOLDER_PATTERN = `^\\s*(${PLACEHOLDERS.map(escape).join('|')})\\s*$`;

const placeholderRegExp = new RegExp(PLACEHOLDER_PATTERN, 'i');

/** Whether a value is only a placeholder, like "volgt" or "N/A". */
export const isPlaceholder = (value: unknown): boolean =>
  typeof value === 'string' && placeholderRegExp.test(value);
